export default __webpack_public_path__ + "static/media/bg-tablet.f46d9129.png";